import { render } from "./TemplateManagement.vue?vue&type=template&id=563d500d&scoped=true"
import script from "./TemplateManagement.vue?vue&type=script&lang=js"
export * from "./TemplateManagement.vue?vue&type=script&lang=js"

import "./TemplateManagement.vue?vue&type=style&index=0&id=563d500d&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2517490718/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-563d500d"]])

export default __exports__